import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { POST_SELECTED_WHEN } from "../../store/action";
import { configureCrisp } from "../../utils/crispConfig";
import FoodSafety from "../elements/food-safety";
import { dayPlusOne } from "../functions/dateFunctions";
import "../styles/layout.css";

const LayoutFoodSafety = () => {

  let selectedWhen = useSelector((state) => state.selectedWhen);
  let selectedLang = useSelector((state) => state.lang);
  let userData = useSelector((state) => state.user);

  const dispatch = useDispatch();

  useEffect(() => {
    configureCrisp({
      autoload: true,
      lockMaximized: false,
      lockFullview: false
    });
    initialData();
  }, []);

  const initialData = async () => {
    const tday = dayPlusOne();
    if (selectedWhen === null || selectedWhen < tday) {
      WhenDate(tday);
    }

  };

  const WhenDate = (value) => dispatch(post_selected_when(value));

  return (
    <div className="global-block">
      <div className="full-block">
        <FoodSafety lang={selectedLang} user={userData} />
      </div>
    </div>
  );
};

export default LayoutFoodSafety;

const post_selected_when = (data) => ({
  type: POST_SELECTED_WHEN,
  data: data
});
